import React from 'react';
import styles from './styles';
import {
    Button,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogActions,
    DialogTitle,
    Typography,
    Container,
} from '@material-ui/core';

const ventanaDialogo = (props) => {
    const classes = styles();

    const dibujarContenido = () => {
        if (props.contenido) {
            return (
                <Container className={classes.containerContenido} style={{whiteSpace:props.whiteSpace}}>
                    {props.contenido}
                </Container>
            );
        }

        return (
            <DialogContentText className={`${classes.mensaje} ${props.esAlerta&&classes.mensajeAlerta}`}>
                {props.mensaje}
            </DialogContentText>
        );
    };

    const mostrarBtnCancelar = () => {
        if (props.clickCancelar) {
            return (
                <Button
                    onClick={props.clickCancelar}
                    variant='text'
                    className={classes.btn}
                >
                    <Typography className={classes.botonCancelar}>
                        Cancelar
                    </Typography>
                </Button>
            );
        }
    };

    const mostrarBtnAceptar = () => {
        if (props.clickSuccess) {
            return (
                <Button
                    onClick={props.clickSuccess}
                    variant='text'
                    className={classes.btn}
                    disabled={props.deshabilitarAceptar}
                >
                    <Typography className={classes.boton}>
                        {props.textoBtnAceptar}
                    </Typography>
                </Button>
            );
        }
    };

    return (
        <Dialog
            open={props.mostrar}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
            maxWidth={false}
        >
            <DialogTitle id='alert-dialog-title'>
                <Typography className={classes.titulo}>
                    {props.titulo}
                </Typography>
            </DialogTitle>
            <DialogContent id='alert-dialog-description'>
                {dibujarContenido()}
            </DialogContent>
            <DialogActions className={classes.containerBtn}>
                {mostrarBtnCancelar()}
                {mostrarBtnAceptar()}
            </DialogActions>
        </Dialog>
    );
};

export default ventanaDialogo;
